module.exports = __webpack_public_path__ + "static/procesKreacjaDesktop@x2-f1f7e661d417a426278552971c827bb2.png";